import React from 'react'

import IconLoading from '@/assets/lottie/loading.json'

import Lottie from 'lottie-react'

interface LoadingLottieProps {
  className?: string
  onClick?: () => void
}

export const LoadingLottie: React.FC<LoadingLottieProps> = ({ className, ...props }) => {
  return <Lottie animationData={IconLoading} loop={true} className={className} {...props} />
}
